<div class="row">
    <ul class="btn-group-org">
        <li class="btn-org" routerLink="equipos" routerLinkActive="active">Equipos</li>
        <li class="btn-org" routerLink="permisos" routerLinkActive="active">Permisos</li>
        <li class="btn-org" routerLink="tipo-preg" routerLinkActive="active">Tipos de preguntas</li>
        <li class="btn-org" routerLink="estados" routerLinkActive="active">Estados de encuesta</li>
    </ul>
</div>
<div class="container-fluid">
    <router-outlet></router-outlet>
</div>